import { DownloadIcon, PDFIcon } from '../../../../../../assets/icons';
import styles from './style.module.scss';

interface Props {
    resumeFileKey: string | undefined;
    certificateFileKey: string | undefined;
    coverLetterFileKey: string | undefined;
    portfolioFileKey: string | undefined;
    resumeFileKeyLink: string | undefined;
    portfolioFileKeyLink: string | undefined;
    certificateFileKeyLink: string | undefined;
    coverLetterFileKeyLink: string | undefined;
};

export default function UploadedFiles(props: Props) {
    const {
        resumeFileKey,
        portfolioFileKey,
        certificateFileKey,
        coverLetterFileKey,
        resumeFileKeyLink,
        portfolioFileKeyLink,
        certificateFileKeyLink,
        coverLetterFileKeyLink,
    } = props;

    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>Resume</span>
                    {resumeFileKeyLink && <a href={resumeFileKeyLink} target='_blank'>
                        <DownloadIcon />
                    </a>}
                </div>
                <div className={styles.content_main}>
                    {resumeFileKey ?
                        <div className={styles.content_main_row}>
                            <PDFIcon />
                            <span className={styles.content_main_row_title}>{resumeFileKey}</span>
                        </div> : <span className={styles.content_main_noData}>No file.</span>}
                </div>
            </div>

            <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>Portfolio</span>
                    {portfolioFileKeyLink && <a href={portfolioFileKeyLink} target='_blank'>
                        <DownloadIcon />
                    </a>}
                </div>
                <div className={styles.content_main}>
                    {portfolioFileKey ? <div className={styles.content_main_row}>
                        <PDFIcon />
                        <span className={styles.content_main_row_title}>{portfolioFileKey}</span>
                    </div> : <span className={styles.content_main_noData}>No file.</span>}
                </div>
            </div>

            <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>Cover letter</span>
                    {coverLetterFileKeyLink && <a href={coverLetterFileKeyLink} target='_blank'>
                        <DownloadIcon />
                    </a>}
                </div>
                <div className={styles.content_main}>
                    {coverLetterFileKey ? <div className={styles.content_main_row}>
                        <PDFIcon />
                        <span className={styles.content_main_row_title}>{coverLetterFileKey}</span>
                    </div> : <span className={styles.content_main_noData}>No file.</span>}
                </div>
            </div>

            <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>Certificate</span>
                    {certificateFileKeyLink && <a href={certificateFileKeyLink} target='_blank'>
                        <DownloadIcon />
                    </a>}
                </div>
                <div className={styles.content_main}>
                    {certificateFileKey ? <div className={styles.content_main_row}>
                        <PDFIcon />
                        <span className={styles.content_main_row_title}>{certificateFileKey}</span>
                    </div> : <span className={styles.content_main_noData}>No file.</span>}
                </div>
            </div>
        </div>
    )
}
